import plannerScaffoldSchedule from './plannerScaffoldSchedule.json';

// Single source of truth for the schedule groups: order, labels, default
// accordion state, and the PlannerEvent stage each group maps to.
export const PLANNER_SCHEDULE_SECTIONS = [
  {key: 'incomplete', label: 'Active', stage: 'active', defaultOpen: true},
  {key: 'upcoming', label: 'Upcoming', stage: 'upcoming', defaultOpen: true},
  {key: 'later', label: 'Later', stage: 'upcoming', defaultOpen: true},
  {
    key: 'completed',
    label: 'Completed',
    stage: 'completed',
    defaultOpen: false,
  },
  {key: 'noShows', label: 'No Show', stage: 'noShow', defaultOpen: false},
];

export const getPlannerScaffoldSchedule = () =>
  plannerScaffoldSchedule.schedule;

export const getVisiblePlannerScheduleSections = (
  schedule: any,
  sections = PLANNER_SCHEDULE_SECTIONS,
) =>
  sections
    .map(section => ({
      ...section,
      items: schedule?.[section.key] || [],
    }))
    .filter(section => section.items.length > 0);

export const getPlannerScheduleTotal = (visibleSections: any) =>
  visibleSections.reduce(
    (count: any, section: any) => count + section.items.length,
    0,
  );
